import React from 'react';
import PropTypes from 'prop-types';

import getColumns from './Columns';
import Title from '../../Title';
import List from '../shared/List';
import Filters from '../../../main/reports/filters/FiltersContainer';
import ExportableReport from '../../../main/reports/ExportableReport';
import ProductInventoryActionFilter from './ProductInventoryActionFilter';

const ProductInventoryReport = props => (
  <div>
    <Title namespace="report">Inventory report</Title>
    <div className="c-wrapper o-page-height">
      <Filters
        csv={props.downloadCsv}
        submit={props.getReport}
        disableBarberFilter
        showCsvExport={props.canLoadReport}
      >
        <div className="c-form-input-group__item u-ml-">
          <ProductInventoryActionFilter />
        </div>
      </Filters>
      <ExportableReport
        canLoadReport={props.canLoadReport}
        name="product-inventory-report"
        label="Product inventory report"
        additionalFilters={{ action: props.getSelectedActions() }}
      >
        <List items={props.report} columns={getColumns(props.report)} />
      </ExportableReport>
    </div>
  </div>
);

ProductInventoryReport.propTypes = {
  downloadCsv: PropTypes.func.isRequired,
  canLoadReport: PropTypes.bool.isRequired,
  report: PropTypes.array.isRequired,
  getSelectedActions: PropTypes.func.isRequired,
};

export default ProductInventoryReport;
